export default "__VITE_ASSET__anWAW_84__"